<template>
  <button class="text-white bg-blue rounded-full font-semibold lg:w-full w-12 h-12 p-3 hover:bg-darkblue duration-75 transition">
    <p class="hidden lg:block">Tweet</p>
    <p class="lg:hidden block"><font-awesome-icon icon="plus" /></p>
  </button>
</template>

<script>
export default {

  name: 'TweetButton',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>
